module.exports = __webpack_public_path__ + "img/feature-3.d6e481af.png";